import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { some } from 'lodash';
import { IconButton } from '@material-ui/core';

import { getDestinations } from '../../../../../actions/deActions/deDistributeActions';
import IconCheckBoxFilled from '../../../shared/icons/IconCheckBoxFilled';
import { STATUS_LIST } from '../../../shared/DEConstants';
import DestinationModalContent from '../DestinationModalContent';
import DeDialog from '../../../shared/DeDialog';
import {
  setDestinationDetails,
  getDesinationPassword,
} from '../../../../../actions/deActions/deDistributeActions';
import IconCheckBoxFilledDisabled from '../../../shared/icons/IconCheckBoxFilledDisabled';

const Destinations = () => {
  const dispatch = useDispatch();
  const [isPartnerModalOpen, setIsPartnerModalOpen] = useState(false);
  const destinations = useSelector(state => state.deDistribute.destinations);
  const distRequest = useSelector(state => state.deDistribute.distRequest);
  const { impersonated, currentAccountId } = useSelector(
    state => state.login.loginResponse.data
  );
  const { data = [], isLoading = true } = destinations;
  const [activePartner, setActivePartner] = useState(null);
  const [buttonType, setButtonType] = useState('ADD');
  useEffect(() => {
    dispatch(getDestinations());
  }, []);

  let isDestDisabled = true;

  if (!distRequest.status || STATUS_LIST.includes(distRequest.status)) {
    isDestDisabled = false;
  }

  const _handleCloseModal = () => {
    setIsPartnerModalOpen(false);
    setActivePartner(null);
  };

  const setPartnerDetails = partner => {
    dispatch(setDestinationDetails(partner));
    _handleCloseModal(null);
  };

  const _getDesinationPassword = destinationId => {
    dispatch(getDesinationPassword(distRequest.requestId, destinationId));
  };

  const _handleOnPartnerSelect = partner => {
    if (
      distRequest.dest.length &&
      some(distRequest.dest, elem => String(elem.id) === String(partner.id))
    ) {
      setButtonType('UPDATE');
      const distPartner = distRequest.dest.find(
        ({ id }) => String(id) === String(partner.id)
      );
      setActivePartner(distPartner);
    } else {
      setButtonType('ADD');
      setActivePartner(partner);
    }
    setIsPartnerModalOpen(true);
  };

  const _handleUnselect = partner => {
    // set logic to add the multiple partner
    // set logic to remove the partner
    if (
      distRequest.dest.length &&
      some(distRequest.dest, elem => String(elem.id) === String(partner.id))
    ) {
      dispatch(setDestinationDetails(partner, true));
    }
  };

  const _renderPartnerList = parnters => {
    if (parnters.length > 0) {
      return parnters.map(partner => {
        const { logo, name, id } = partner;
        let rootClass = 'distro__partner--card';
        let isSelected = false;
        // change this logic to check from arry of selected partners
        if (
          distRequest.dest.length > 0 &&
          some(distRequest.dest, elem => String(elem.id) === String(id))
        ) {
          rootClass += '  distro__partner--card__selected';
          isSelected = true;
        }
        if (activePartner && activePartner.id === id) {
          rootClass += ' distro__partner--card__active';
        }
        return (
          <div key={id} className="distro__partners--list--col">
            <div className={rootClass}>
              {isSelected && (
                <div className="distro__partner--card__selected-checkbox">
                  <IconButton
                    type="button"
                    onClick={() => _handleUnselect(partner)}
                    disabled={isDestDisabled}
                  >
                    {isDestDisabled ? (
                      <IconCheckBoxFilledDisabled />
                    ) : (
                      <IconCheckBoxFilled />
                    )}
                  </IconButton>
                </div>
              )}
              <button
                type="button"
                onClick={() => _handleOnPartnerSelect(partner)}
                className="distro__partner--card--button"
                disabled={isDestDisabled}
              >
                <div className="distro__partner--image">
                  <img src={logo} alt={name} />
                </div>
                <div className="distro__partner--title">{name}</div>
              </button>
            </div>
          </div>
        );
      });
    }
    return null;
  };
  const _renderPartners = () => {
    if (isLoading) {
      return <div className="distro__partners">loading...</div>;
    }
    if (data.length === 0) {
      return <div className="distro__partners">No partner available</div>;
    }
    const totalDestinations = distRequest.dest.length;
    let message = 'destination selected';
    if (distRequest.dest.length > 1) {
      message = `destinations selected`;
    }
    return (
      <div className="distro__partners">
        <div className="distro__partners--selection">
          <div className="distro__partners--selection--empty">
            {totalDestinations > 0
              ? `${totalDestinations} ${message}`
              : 'No destinations currently selected'}
          </div>
          {totalDestinations > 0 && (
            <div className="distro__partners--list">
              <div className="distro__partners--list--row">
                {_renderPartnerList(distRequest.dest)}
              </div>
            </div>
          )}
        </div>
        {!isDestDisabled && (
          <div className="distro__partners--list">
            <div className="distro__partners--list--row">
              {_renderPartnerList(data)}
            </div>
          </div>
        )}
      </div>
    );
  };
  return (
    <div className="distro__row distro__dest">
      <div className="distro__dest--title">
        <h3>Destinations</h3>
      </div>
      {_renderPartners()}
      {isPartnerModalOpen && (
        <DeDialog
          className="distro__partner--modal--root"
          open={isPartnerModalOpen}
          title="Enter Destination Details"
          id="dialog-partner"
          onClose={_handleCloseModal}
        >
          <DestinationModalContent
            partner={activePartner}
            setPartnerDetails={setPartnerDetails}
            buttonType={buttonType}
            impersonated={impersonated}
            currentAccountId={currentAccountId}
            getDesinationPassword={_getDesinationPassword}
          />
        </DeDialog>
      )}
    </div>
  );
};

export default Destinations;
